import React, { useState, useEffect, useRef } from "react";
import { MdOutlineFileCopy, MdDelete, MdDriveFileMove } from "react-icons/md";
import { IoIosInformationCircle, IoMdShare } from "react-icons/io";
import { FaDownload, FaEllipsisH, FaEye } from "react-icons/fa";
import renameIcon from "../../assets/images/rename-icon.png";
import { fileMonths } from "../../utils";
import FolderDialog from "./FolderDialog";
import useAuth from "../../hooks/useAuth";
import moment from "moment";
import fileImg from '../../assets/images/file_img.jpg';
import moreVertical from '../../assets/images/more_vertical.svg';
import infoIcon from '../../assets/images/info_icon.svg';
import fileIcon from '../../assets/images/file.png'
import downloadBlack from '../../assets/images/download_black.svg';
import deleteIcon from '../../assets/images/delete_icon.svg';
import MediaViewerDialog from "../creativeApproval/MediaViewerDialog";
import Loader from "../../utils/Loader";
import { convertPSDImage, getRecentRepositoryFiles } from "../../redux/slices/apiSlice";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import InfiniteScroll from 'react-infinite-scroll-component';
import { FETCH_DURATION, MAX_FETCH_DURATION } from "../../config/constant";




const FileListing = ({
  displayedFolders,
  fileImage,
  getFileIcon,
  setOpenRenameDialog,
  setClickedFolderId,
  setOpenDeleteDialogFile,
  handleDownloadAction,
  selectedYear,
  setSelectedYear,
  yearOptions,
  isLandingPage
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewImageDownloadId, setPreviewImageDownloadId] = useState(null);
  const [selectFilesEnabled, setSelectFilesEnabled] = useState(false);
  const [tooltipFile, setTooltipFile] = useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [imagePreview, setImagePreview] = useState(false);
  const menuRef = useRef(null);
  const { user } = useAuth()
  const [openMediaViewer, setOpenMediaViewer] = useState(false);
  const [psdImageData, setPsdImageData] = useState(null);
  const [activeTab, setActiveTab] = useState("");
  const [previewFile, setPreviewFile] = useState([]);
  const dispatch = useDispatch();
  const [recentFolderList, setRecentFolderList] = useState(displayedFolders);
  const [hasMoreRecentFolders, setHasMoreRecentFolders] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const fetchDuration = FETCH_DURATION;
  const [fetchedDaysCount, setFetchedDaysCount] = useState(fetchDuration);
  const { repositoryIDsList } = useSelector((state) => state.api);
  const debounceRef = useRef(null);

  useEffect(() => {
    let debounceTimer;
    if (!recentFolderList || recentFolderList.length <= 0) {
      debounceTimer = setTimeout(() => {
        fetchNextRepoList();
      }, 500);
    }
    return () => clearTimeout(debounceTimer);
  }, [recentFolderList]);



  const fetchNextRepoList = async (fetchedDays = null) => {
    setIsFetching(true);
    let next = fetchedDays ? (fetchedDays + fetchDuration) : fetchedDaysCount;
    let repoIdsList = repositoryIDsList;
    for (let i = next; i <= (MAX_FETCH_DURATION - fetchDuration); i += fetchDuration) {
      next += fetchDuration;
      const response = await dispatch(getRecentRepositoryFiles({ payload: { daysCount: fetchDuration, startDaysCount: i }, excludedIdList: repoIdsList }));
      if (response?.payload?.data?.result?.length) {
        repoIdsList = (response?.payload?.data?.result).map(item => item._id);
        setRecentFolderList(prev => [...prev, ...response?.payload?.data?.result]);
        break;
      }
    }
    setFetchedDaysCount(next);
    setIsFetching(false);
  }

  const myApiFetch = async () => {
    const response = await dispatch(getRecentRepositoryFiles({ payload: { daysCount: fetchDuration, startDaysCount: fetchedDaysCount }, excludedIdList: repositoryIDsList }));
    setFetchedDaysCount(prev => (prev + fetchDuration));
    return response?.payload?.data?.result;

  };


  const ImageDownloadPreview = ({ src, fileName, download }) => {
    return (
      <div className="flex flex-col gap-5 items-start">
        <div className="flex items-center w-full gap-2 flex-col">
          <div className="w-30 h-52">
            <img src={src} className="w-full h-full object-cover" />
          </div>
        </div>
        <button
          className="flex gap-2 p-3 bg-blue-500 hover:bg-blue-600 text-sm transition-all ease-in-out duration-700 justify-center items-center rounded text-white"
          onClick={download}
        >
          <span>Download</span>
        </button>
      </div>
    );
  };

  // Toggle individual file selection
  const toggleFileSelection = (fileId) => {
    setSelectedFiles((prev) =>
      prev.includes(fileId)
        ? prev.filter((id) => id !== fileId)
        : [...prev, fileId]
    );
  };

  // Toggle "Select Files" option
  const toggleSelectFiles = () => {
    setSelectFilesEnabled(!selectFilesEnabled);
    if (!selectFilesEnabled) {
      setSelectedFiles([]); // Reset selections when disabled
    }
  };

  // Toggle "Select All"
  const toggleSelectAll = () => {
    if (selectedFiles.length === displayedFolders.length) {
      setSelectedFiles([]); // Unselect all
    } else {
      setSelectedFiles(displayedFolders.map((file) => file._id)); // Select all
    }
  };


  const toggleFileMenu = (file) => {
    if (openMenuId?._id == file?._id) {
      setOpenMenuId(null)
    } else {
      setOpenMenuId(file)
    }
  };


  // Action buttons should only turn blue if at least one file is selected
  const isActionEnabled = selectFilesEnabled && selectedFiles.length > 0;
  const actionColor = isActionEnabled ? "text-blue-500" : "text-gray-400";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setTimeout(() => {
          setOpenMenuId(null);
        }, 500);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const sortedFiles = displayedFolders
    .filter((folder) => folder.type === "file")
    .reduce((acc, file) => {
      const month = file.tags?.[0]?.toLowerCase();
      if (fileMonths.includes(month)) {
        acc[month] = acc[month] || [];
        acc[month].push(file);
      }
      return acc;
    }, {});
  useEffect(() => {
    let currentMonthName = moment().format('MMMM').toLowerCase();
    (!activeTab || (activeTab && !sortedFiles?.[activeTab]?.length)) && setActiveTab(sortedFiles && Object.keys(sortedFiles).length > 0 ? (Object.keys(sortedFiles).includes(currentMonthName) ? currentMonthName : Object.keys(sortedFiles)[0]) : "")
  }, [sortedFiles]);
  const hasFiles = Object.keys(sortedFiles).length > 0;

  const convertPSDImageHandler = async (creativeData) => {
    let response = await dispatch(
      convertPSDImage({ s3Url: creativeData.s3_file_name })
    )
    if (!response.payload || response.error) setPsdImageData({ error: response.error || "Server Errror" });
    response?.payload?.imageDataUrl && setPsdImageData(response.payload.imageDataUrl)
  }


  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setHasMoreRecentFolders(fetchedDaysCount < (MAX_FETCH_DURATION - fetchDuration)); 
  }, [fetchedDaysCount]);


  const fetchMoreRecentFolders = async () => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(async () => {
      try {
        if (isFetching) return;
        setIsFetching(true);
        const newData = await myApiFetch();
        if (newData && newData?.length) {
          setRecentFolderList(prev => [...prev, ...newData]);

        } else {
          await fetchNextRepoList(fetchedDaysCount);
          setIsFetching(false);
          return;
        }
        setIsFetching(false);
      } catch (error) {
        console.error('Error fetching:', error);
        setIsFetching(false);
      }
    }, 500);
  };




  return (
    <div>

      {
        openMediaViewer ?

          ["application/x-photoshop"].includes(previewFile?.file_type) && !psdImageData

            ?

            <Loader />
            :

            <MediaViewerDialog
              isOpen={openMediaViewer}
              content={
                <div className="flex justify-center items-center">
                  {
                    previewFile?.file_type?.startsWith('image/') ?
                      <img
                        alt=""
                        className={`rounded w-full object-cover`}
                        src={previewFile.s3_file_name}
                      />
                      : previewFile?.file_type?.startsWith('video/') ?
                        <video
                          className={`rounded w-full object-cover`}
                          controls
                          style={{ objectFit: 'cover' }}
                        >
                          <source src={previewFile.s3_file_name} type={previewFile.file_type} />
                          Your browser does not support the video tag.
                        </video>
                        : ["application/x-photoshop"].includes(previewFile?.file_type) ?
                          <>{
                            psdImageData?.error ?
                              <p class="text-red-600 font-semibold">
                                PSD preview failed. File may be too large or unsupported.
                              </p>
                              :

                              <img
                                alt=""
                                className={`rounded w-full object-cover`}
                                src={psdImageData}
                              />
                          }


                          </>
                          :
                          <img
                            alt=""
                            className={`rounded h-[100px]  object-cover`}
                            src={previewFile?.s3_file_name
                              ? getFileIcon(previewFile.file_type)
                              : fileIcon
                            }
                          />
                  }
                </div>
              }
              onClose={() => setOpenMediaViewer(false)}
              title="Media Preview"
            />
          : <></>



      }
      {/* <div className="p-4 text-xs text-blue-500"> */}
      {/* <div className="flex items-center space-x-4 text-gray-400 mb-4">
          <label className="flex items-center space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="accent-blue-500"
              checked={selectFilesEnabled}
              onChange={toggleSelectFiles}
            />
            <span>Select Files</span>
          </label>

          {selectFilesEnabled && (
            <label className="flex items-center space-x-1 cursor-pointer">
              <input
                type="checkbox"
                className="accent-blue-500"
                checked={
                  selectedFiles.length === displayedFolders.length &&
                  displayedFolders.length > 0
                }
                onChange={toggleSelectAll}
              />
              <span>Select All</span>
            </label>
          )}

          <button
            className={`flex items-center space-x-1 ${actionColor}`}
            disabled={!isActionEnabled}
          >
            <MdOutlineFileCopy />
            <span>Copy</span>
          </button>
          <button
            className={`flex items-center space-x-1 ${actionColor}`}
            disabled={!isActionEnabled}
          >
            <MdDriveFileMove />
            <span>Move</span>
          </button>
          <button
            className={`flex items-center space-x-1 ${actionColor}`}
            disabled={!isActionEnabled}
          >
            <MdDelete />
            <span>Delete</span>
          </button>
          <button
            className={`flex items-center space-x-1 ${actionColor}`}
            disabled={!isActionEnabled}
          >
            <FaDownload />
            <span>Download</span>
          </button>
        </div> */}
      {/* </div> */}

      {/* File Grid */}




      {/* new design start  */}
      {(hasFiles || isLandingPage) && (
        <div className="file_section_wrap">
          <div className="file_section_head  flex items-center justify-between">
            <h6>{isLandingPage ? "Recent Files" : "Files"}</h6>
            {!isLandingPage ?
              <div>
                <Select
                  options={yearOptions.map(year => ({
                    label: year,
                    value: year
                  }))}
                  value={{
                    label: selectedYear || moment().year(),
                    value: selectedYear || moment().year()
                  }}
                  className='customSelectBox1'
                  onChange={(obj) => { setSelectedYear(obj.value); }}
                  placeholder="Choose Year"
                />
              </div>
              : <></>}

          </div>
          {
            isLandingPage && recentFolderList.length ?
              <div className="file_tab_content" id="scrollableRecentFoldersDiv" style={{
                height: recentFolderList.length < 4 ? '300px' : '500px',
                overflow: 'auto',
              }}>
                <InfiniteScroll
                  dataLength={recentFolderList.length}
                  next={fetchMoreRecentFolders}
                  hasMore={hasMoreRecentFolders}
                  // loader={<p style={{ textAlign: 'center' }}>Loading...</p>}
                  loader={
                    isFetching
                      ? <p style={{ textAlign: 'center' }}>Loading...</p>
                      : null
                  }
                  scrollableTarget="scrollableRecentFoldersDiv"
                >
                  <div className="tabs-container">
                    <div className="tabs-content">
                      <div className="tabs-content-wrap"  >


                        {recentFolderList.map((file) => (
                          <>

                            <div className="tabs-content-card">
                              <div className="content-card-img">
                                {
                                  file.file_type.startsWith('image/') ?
                                    <img
                                      alt=""
                                      height="140px"
                                      width="100%"
                                      src={file.s3_file_name}
                                    />
                                    : file.file_type.startsWith('video/') ?
                                      <video
                                        height="140px"
                                        width="100%"
                                        controls
                                        style={{ objectFit: 'cover' }}
                                      >
                                        <source src={file.s3_file_name} type={file.file_type} />
                                        Your browser does not support the video tag.
                                      </video>
                                      :
                                      <img
                                        alt=""
                                        height="140px"
                                        width="100%"
                                        src={file.s3_file_name
                                          ? getFileIcon(file.s3_file_name)
                                          : fileImage
                                        }
                                      />
                                }

                                <button type="button" class="vertical_more_btn" onClick={() => toggleFileMenu(file)}>
                                  <img
                                    alt=""
                                    height="24px"
                                    width="24px"
                                    src={moreVertical}
                                  />
                                </button>
                                {openMenuId?._id === file._id && (
                                  <div className="filter_dropdown_box">
                                    {/* <button
                                            className="filter_dropdown_btn"
                                            onClick={() => {
                                              setOpenRenameDialog(true);
                                              setClickedFolderId(file._id);
                                            }}
                                          >
                                            <img
                                              alt=""
                                              width="16px"
                                              height="16px"
                                              src={editIcon}
                                            />
                                            Rename
                                          </button> */}
                                    {/* <button
                                            className="filter_dropdown_btn"

                                          >
                                            <img
                                              alt=""
                                              width="16px"
                                              height="16px"
                                              src={copyIcon}
                                            />
                                            Copy
                                          </button> */}
                                    <button
                                      className="filter_dropdown_btn"
                                      onClick={() => {
                                        setOpenMenuId(null); setOpenMediaViewer(!openMediaViewer); setPreviewFile(file);

                                        if (file?.file_type?.startsWith('image/') || file?.file_type?.startsWith('video/') || ["application/x-photoshop"].includes(file?.file_type)) {
                                          setOpenMediaViewer(true);
                                          setOpenMenuId(null);
                                          setPsdImageData(null);
                                          ["application/x-photoshop"].includes(file?.file_type) && convertPSDImageHandler(file);
                                        }

                                      }}
                                    >
                                      <FaEye size={16} />

                                      Preview
                                    </button>
                                    <button
                                      className="filter_dropdown_btn"
                                      onClick={() => { setOpenMenuId(null); handleDownloadAction(file); }}
                                    >
                                      <img
                                        alt=""
                                        width="16px"
                                        height="16px"
                                        src={downloadBlack}
                                      />
                                      Download
                                    </button>
                                    {
                                      file?.owner_id?._id == user?._id &&
                                      <button
                                        className="filter_dropdown_btn delete_btn"
                                        onClick={() => {
                                          setOpenMenuId(null);
                                          setOpenDeleteDialogFile(true);
                                          setClickedFolderId(file._id);
                                        }}
                                      >
                                        <img
                                          alt=""
                                          width="16px"
                                          height="17px"
                                          src={deleteIcon}
                                        />
                                        Delete
                                      </button>
                                    }
                                  </div>
                                )}
                              </div>

                              <div className="content-card-title">
                                <h6 title={file.name}>{file.name}</h6>
                                <div className="tooltip-wrapper">
                                  <button type="button" className="tooltip-icon">
                                    <img
                                      alt=""
                                      height="18px"
                                      width="18px"
                                      src={infoIcon}
                                    />
                                  </button>
                                  <span className="tooltip-text">

                                    <p>
                                      {file?.owner_id?.email || "N/A"}
                                    </p>
                                    <p>
                                      {file.createdAt ? moment(file.createdAt).format("DD MMM YYYY") : ""}
                                    </p>

                                  </span>
                                </div>
                              </div>
                              {/* <div className="downloadBtnWrap">
                                      <button type="button" className="downloadBtn" onClick={() => handleDownloadAction(file)}>
                                        <img src={downloadIcon} alt="logo" /> Download
                                      </button>
                                    </div> */}
                            </div>

                          </>

                        ))}

                      </div>
                    </div>

                  </div>
                </InfiniteScroll>
                {
                  !hasMoreRecentFolders &&
                  <div className="recentFilesBottomMsg">
                    {`That's all your files from the last ${MAX_FETCH_DURATION} days.`}
                  </div>
                }
              </div>
              :
              <></>
          }

          {!isLandingPage ?
            <div className="file_tab_content">
              <div className="tabs-container">
                <div className="tabs-header">
                  {fileMonths.map((month) =>
                  (
                    <button
                      className={`${!Object.keys(sortedFiles).includes(month) ? "tabHeaderInactive" : "tabHeaderData"}  ${activeTab === month?.toLowerCase() ? "active" : ""}`}
                      onClick={() => setActiveTab(month?.toLowerCase())}
                    >
                      {month[0].toUpperCase() + month.slice(1)}
                    </button>
                  ))}
                </div>

                <div className="tabs-content">

                  {fileMonths.map((month) =>
                    sortedFiles[month] && sortedFiles[month].length > 0 ?
                      <>
                        {activeTab === month?.toLowerCase() &&
                          <div className="tabs-content-wrap">

                            {sortedFiles[month].map((file) => (

                              <>

                                <div className="tabs-content-card">
                                  <div className="content-card-img">
                                    {
                                      file.file_type.startsWith('image/') ?
                                        <img
                                          alt=""
                                          height="140px"
                                          width="100%"
                                          src={file.s3_file_name}
                                        />
                                        : file.file_type.startsWith('video/') ?
                                          <video
                                            height="140px"
                                            width="100%"
                                            controls
                                            style={{ objectFit: 'cover' }}
                                          >
                                            <source src={file.s3_file_name} type={file.file_type} />
                                            Your browser does not support the video tag.
                                          </video>
                                          :
                                          <img
                                            alt=""
                                            height="140px"
                                            width="100%"
                                            src={file.s3_file_name
                                              ? getFileIcon(file.s3_file_name)
                                              : fileImage
                                            }
                                          />
                                    }

                                    <button type="button" class="vertical_more_btn" onClick={() => toggleFileMenu(file)}>
                                      <img
                                        alt=""
                                        height="24px"
                                        width="24px"
                                        src={moreVertical}
                                      />
                                    </button>
                                    {openMenuId?._id === file._id && (
                                      <div className="filter_dropdown_box">
                                        {/* <button
                                            className="filter_dropdown_btn"
                                            onClick={() => {
                                              setOpenRenameDialog(true);
                                              setClickedFolderId(file._id);
                                            }}
                                          >
                                            <img
                                              alt=""
                                              width="16px"
                                              height="16px"
                                              src={editIcon}
                                            />
                                            Rename
                                          </button> */}
                                        {/* <button
                                            className="filter_dropdown_btn"

                                          >
                                            <img
                                              alt=""
                                              width="16px"
                                              height="16px"
                                              src={copyIcon}
                                            />
                                            Copy
                                          </button> */}
                                        <button
                                          className="filter_dropdown_btn"
                                          onClick={() => {
                                            setOpenMenuId(null); setOpenMediaViewer(!openMediaViewer); setPreviewFile(file);

                                            if (file?.file_type?.startsWith('image/') || file?.file_type?.startsWith('video/') || ["application/x-photoshop"].includes(file?.file_type)) {
                                              setOpenMediaViewer(true);
                                              setOpenMenuId(null);
                                              setPsdImageData(null);
                                              ["application/x-photoshop"].includes(file?.file_type) && convertPSDImageHandler(file);
                                            }

                                          }}
                                        >
                                          <FaEye size={16} />

                                          Preview
                                        </button>
                                        <button
                                          className="filter_dropdown_btn"
                                          onClick={() => { setOpenMenuId(null); handleDownloadAction(file); }}
                                        >
                                          <img
                                            alt=""
                                            width="16px"
                                            height="16px"
                                            src={downloadBlack}
                                          />
                                          Download
                                        </button>
                                        {
                                          file?.owner_id?._id == user?._id &&
                                          <button
                                            className="filter_dropdown_btn delete_btn"
                                            onClick={() => {
                                              setOpenMenuId(null);
                                              setOpenDeleteDialogFile(true);
                                              setClickedFolderId(file._id);
                                            }}
                                          >
                                            <img
                                              alt=""
                                              width="16px"
                                              height="17px"
                                              src={deleteIcon}
                                            />
                                            Delete
                                          </button>
                                        }
                                      </div>
                                    )}
                                  </div>

                                  <div className="content-card-title">
                                    <h6 title={file.name}>{file.name}</h6>
                                    <div className="tooltip-wrapper">
                                      <button type="button" className="tooltip-icon">
                                        <img
                                          alt=""
                                          height="18px"
                                          width="18px"
                                          src={infoIcon}
                                        />
                                      </button>
                                      <span className="tooltip-text">

                                        <p>
                                          {file?.owner_id?.email || "N/A"}
                                        </p>
                                        <p>
                                          {file.createdAt ? moment(file.createdAt).format("DD MMM YYYY") : ""}
                                        </p>

                                      </span>
                                    </div>
                                  </div>
                                  {/* <div className="downloadBtnWrap">
                                      <button type="button" className="downloadBtn" onClick={() => handleDownloadAction(file)}>
                                        <img src={downloadIcon} alt="logo" /> Download
                                      </button>
                                    </div> */}
                                </div>

                              </>
                            ))}
                          </div>
                        } </> : <></>)}

                </div>
              </div>
            </div>
            :
            <></>}
        </div>
      )}

      {/* new design end  */}
    </div>
  );
};

export default FileListing;
